export default __webpack_public_path__ + "static/media/AcceleronsGallery_41.a13b5817.webp";